import { Browser } from '@capacitor/browser'

import { createCheckoutLink } from '@/api/auth/checkoutLinkService'

import { getAuthTokens } from './authTokens'
import { isNativePlatform } from './platform'

export async function openNativeCheckout(path: string, pkgId: string): Promise<void> {
  if (!isNativePlatform()) return
  const tokens = getAuthTokens()
  if (!tokens?.refreshToken) {
    throw new Error('Missing session for checkout')
  }

  const { url } = await createCheckoutLink({
    path,
    pkgId,
    refreshToken: tokens.refreshToken,
    accessToken: tokens.accessToken,
    idToken: tokens.idToken,
  })

  await Browser.open({ url, presentationStyle: 'popover' })
}
